'use strict';

var _require = require('./baseProperties'),
    baseProperties = _require.baseProperties;

module.exports.AppRoleSchema = {
  title: 'AppRole',
  type: 'object',
  properties: Object.assign({}, baseProperties)
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/schema/appRole.js
// module id = u/ch
// module chunks = 0